import { AfterViewInit, Component, Input, OnInit } from '@angular/core'
import { NbDialogRef, NbDialogService } from '@nebular/theme'
import { ITurnInfo } from 'src/app/@core/services/working.service'
import _ from 'lodash'
import { ButtonType, PvsFormDialogComponent, PvsFormResponse } from '../pvs-form-dialog/pvs-form-dialog.component'
import { ViewChild, ElementRef } from '@angular/core'
import { TurnInputRedeemComponent } from '../turn-input-redeem/turn-input-redeem.component'

export enum ETurnInputMode {
    NEW,
    UPDATE,
    DELETE,
}

@Component({
    templateUrl: './turn-input-dialog.component.html',
    styleUrls: ['./turn-input-dialog.component.scss'],
    selector: 'app-turn-input-dialog',
})
export class TurnInputDialogComponent implements OnInit, AfterViewInit {
    SALES_TAX: number = 7.63 // percent
    CREDIT_CARD_FEE: number = 0 // 2.9 // percent
    CASH_DISCOUNT_PERCENT: number = 5
    EMode = ETurnInputMode
    @Input() mode: ETurnInputMode = ETurnInputMode.NEW
    @Input() data: ITurnInfo
    @Input() employee: any
    @Input() okFunction: Function
    @Input() deleteFunction: Function
    tmpData: ITurnInfo = {
        type: 'normal',
        turnOrderNo: 0,
        amt: null,
        tip: null,
        paidInCashAmt: null,
        redeemAmt: null,
        redeems: [],
        paymentStatus: 'pending',
        isClientRequested: false,
        histories: [],
    }
    amtTaxIncluded: number
    cashEstimation: number
    cardEstimation: number
    typeOption: string = 'normal'
    typeOptions = [
        { value: 'normal', label: 'Normal turn' },
        { value: 'crying', label: 'Crying turn' },
    ]
    cashOption: string = 'none'
    cashOptions = [
        { value: 'none', label: 'None' },
        { value: 'all', label: 'All' },
        { value: 'custom', label: 'Custom' },
    ]
    redeemOption: string = 'no'
    redeemOptions = [
        { value: 'no', label: 'No' },
        { value: 'yes', label: 'Yes' },
    ]
    clientRequested: string = 'no'
    clientRequestedOptions = [
        { value: 'no', label: 'No' },
        { value: 'yes', label: 'Yes' },
    ]
    paymentStatusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'done', label: 'Completed' },
    ]
    protected dialogRef: NbDialogRef<any>
    currentHistoryId: number
    preventRedeemChangeEvent: boolean = false
    @ViewChild('amt', { static: false }) amtRef: ElementRef
    allowOkButtonClick: boolean = true // prevent pressing the button multiple times at once.

    constructor(dialogRef: NbDialogRef<any>, private dialogService: NbDialogService) {
        this.dialogRef = dialogRef
    }

    ngOnInit() {
        if (this.data) {
            this.tmpData = Object.assign({}, this.data)
            if (this.tmpData.histories?.length) {
                this.tmpData.histories = _.orderBy(this.tmpData.histories, 'id', 'desc')
                this.currentHistoryId = this.tmpData.histories.reduce((a, b) => (a.id > b.id ? a : b))?.id
            }
        }
        this.mapData()
        this.onChangeAmt()
        this.setToOptions()
    }
    ngAfterViewInit(): void {
        if (this.typeOption === 'normal') {
            this.amtRef.nativeElement?.focus()
        }
        this.onChangeAmt()
    }
    onChangeAmt(redeemOption = null) {
        this.amtTaxIncluded = null
        this.cardEstimation = null
        this.cashEstimation = null
        if (!this.tmpData || !this.tmpData.amt) {
            return
        }
        const redeemAmt = (redeemOption || this.redeemOption) === 'yes' ? this.tmpData.redeemAmt : 0
        // add tax, subtract redeem
        const haveToPayAmt = (this.tmpData.amt * (100 + this.SALES_TAX)) / 100 - redeemAmt
        this.amtTaxIncluded = haveToPayAmt

        if (this.cashOption !== 'custom') {
            // card
            // add card fee
            this.cardEstimation = (haveToPayAmt * (100 + this.CREDIT_CARD_FEE)) / 100
            this.cardEstimation = Math.round(this.cardEstimation * 100) / 100

            // cash
            this.cashEstimation = haveToPayAmt
            if (this.CASH_DISCOUNT_PERCENT) {
                this.cashEstimation = (this.cashEstimation * (100 - this.CASH_DISCOUNT_PERCENT)) / 100
            }
            this.cashEstimation = Math.round(this.cashEstimation * 100) / 100
        } else {
            // cashOption === custom
            // cash
            this.cashEstimation = this.tmpData.paidInCashAmt || 0
            const convertedCash = (this.tmpData.paidInCashAmt * (100 + this.CASH_DISCOUNT_PERCENT)) / 100
            // card
            this.cardEstimation = haveToPayAmt - convertedCash
            // add card fee
            this.cardEstimation = (this.cardEstimation * (100 + this.CREDIT_CARD_FEE)) / 100
            this.cardEstimation = Math.round(this.cardEstimation * 100) / 100
        }
    }
    setToOptions() {
        this.preventRedeemChangeEvent = true
        // type
        if ((this.tmpData.type || 'normal') === 'normal') {
            this.typeOption = 'normal'
        } else {
            this.typeOption = 'crying'
        }
        // paid in cash
        if (!this.tmpData.paidInCashAmt) {
            this.cashOption = 'none'
        } else if (this.tmpData.paidInCashAmt === (this.tmpData.amt || 0)) {
            this.cashOption = 'all'
        } else {
            this.cashOption = 'custom'
        }
        // redeem
        // if (this.tmpData.redeemAmt === 0) {
        //     this.tmpData.redeemAmt = null
        // }
        if (!this.tmpData.redeemAmt || !this.tmpData.redeems?.length) {
            this.redeemOption = 'no'
        } else {
            this.redeemOption = 'yes'
        }
        // client requested
        if (!this.tmpData.isClientRequested) {
            this.clientRequested = 'no'
        } else {
            this.clientRequested = 'yes'
        }
        this.preventRedeemChangeEvent = false
    }
    getFromOptions() {
        this.tmpData.type = this.typeOption || 'normal'
        this.tmpData.amt = this.tmpData.amt || 0
        this.tmpData.tip = this.tmpData.tip || 0
        this.tmpData.paidInCashAmt = this.tmpData.paidInCashAmt || 0
        // paidInCashAmt
        if (this.cashOption === 'none') {
            this.tmpData.paidInCashAmt = 0
        } else if (this.cashOption === 'all') {
            this.tmpData.paidInCashAmt = this.tmpData.amt
        }
        // redeem
        if (this.redeemOption === 'no') {
            this.tmpData.redeemAmt = 0
            this.tmpData.redeems = null
        }
        //
        this.tmpData.redeemAmt = this.tmpData.redeemAmt || 0
        // isClientRequested
        if (this.clientRequested === 'no') {
            this.tmpData.isClientRequested = false
        } else {
            this.tmpData.isClientRequested = true
        }
    }
    mapData() {
        if (this.tmpData?.redeems?.length) {
            this.tmpData.redeems = this.tmpData.redeems.map((e) => {
                e.code = e.giftCard?.code || null
                return e
            })
        }
    }
    async onOk() {
        if (!this.allowOkButtonClick) {
            return
        }
        this.allowOkButtonClick = false

        this.mapData()
        this.getFromOptions()
        const res = await this.okFunction(this.tmpData)

        this.allowOkButtonClick = true

        if (res) {
            this.dialogRef.close(res)
        }
    }
    async onDelete() {
        let refundMessage = ''
        if (this.data.redeemAmt > 0) {
            refundMessage = `<p>And the redeemed amount ($${this.data.redeemAmt}) will be <strong>REFUND</strong> to customer's gift card.</p>`
        }
        this.dialogService
            .open(PvsFormDialogComponent, {
                context: {
                    settings: {
                        headerIcon: 'alert-triangle-outline',
                        title: 'Warning',
                        contentHtml: `
                            <p>All related data will also be deleted and cannot be restored.</p>
                            ${refundMessage}
                            <p>Do you want to continue?</p>
                            `,
                        buttonType: ButtonType.YES_NO_10_SECONDS,
                    },
                },
            })
            .onClose.subscribe(async (formRes: PvsFormResponse) => {
                if (!formRes) {
                    return
                }
                const res = await this.deleteFunction()
                if (res) {
                    this.dialogRef.close(null)
                }
            })
    }
    onCancel() {
        this.dialogRef.close()
    }
    onClickHistory(history) {
        this.preventRedeemChangeEvent = true
        this.currentHistoryId = history.id
        for (const key of Object.keys(this.tmpData)) {
            if (['id'].includes(key)) {
                continue
            }
            if (key in history) {
                this.tmpData[key] = history[key]
            }
        }
        this.preventRedeemChangeEvent = false
        this.setToOptions()
    }
    onRedeemOptionsChange(value) {
        if (this.preventRedeemChangeEvent) {
            this.preventRedeemChangeEvent = false
            return
        }
        if (value === 'yes') {
            this.onRedeemDetailClick()
        } else {
            this.onChangeAmt(value)
        }
    }
    onRedeemDetailClick() {
        this.dialogService
            .open(TurnInputRedeemComponent, {
                context: {
                    mode: this.mode,
                    redeems: this.tmpData.redeems,
                    workingTurnId: this.tmpData.id,
                },
            })
            .onClose.subscribe((res) => {
                if (res) {
                    this.tmpData.redeemAmt = res.redeemAmt || 0
                    this.tmpData.redeems = res.redeems || []
                }
                if (!this.tmpData?.redeems?.length && this.redeemOption === 'yes') {
                    this.redeemOption = 'no'
                }
                this.onChangeAmt()
            })
    }
}
